<template>
    <!-- 所有的内容要被根节点包含起来 -->
    <div> 
        <div class="vipSize">
            <img 
                src="../../assets/images/vip_icon.png">
        </div>
    </div>
</template>


<script>
//引入头部组件
export default {
    data(){
        return{
            msg:'喜喜',
        }
    },
    methods:{
      
    },
    components:{
        
    }
}
</script>

<style lang="css" scoped>
/* css 局部作用域 scoped*/
    .vipSize img{
        width:35px;
        height: 15px;
        position: absolute;
        right: 11px;
        
    }

</style>


// WEBPACK FOOTER //
// src/components/getvipimg/getVipImg.vue